// src/routes/app-routes.tsx

import SiteLayout from "../components/site-layout";
import AdminRegistrationPage from "../pages/admin/AddPage";
import AdminDetailViewPage from "../pages/admin/DetailsPage";
import AdminEditViewPage from "../pages/admin/EditPage";
import ListView from "../pages/admin/ListPage";
import KYActivityListPage from "../pages/admin/KYActivityListPage";
import SiteEntryAdd from "../pages/user/SiteEntryAdd";
import PhoneLoginPage from "../pages/user/PhoneLoginPage";
import {
  AllDoneSuccess,
  EntryTraining,
  EntryTrainingMessage,
  ExistScreen,
  RegisterMessage,
  UpdateMessage,
  UserNotExist,
} from "../pages/user/MessageScreens";
import UserDetailsPage from "../pages/user/UserDetailsPage";
import EditViewPage from "../pages/user/UserEditPage";
import UserRegistrationPage from "../pages/user/UserRegistrationPage";
import KYActivityPage from "../pages/user/KYActivityPage";

import NotAuthorized from "../pages/NotAuthorized";
import NotFound from "../pages/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/layout";
import FaceCameraPage from "../pages/user/FaceCamera";
import { Navigate } from "react-router-dom";

export const appRoutes = [
  // ----------- Admin Routes -----------
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute allowedRoles={["admin", "headquaters"]}>
            <ListView />
          </ProtectedRoute>
        ),
      },
      {
        path: "/list",
        element: (
          <ProtectedRoute allowedRoles={["admin", "headquaters"]}>
            <ListView />
          </ProtectedRoute>
        ),
      },
      {
        path: "/detail/:id",
        element: (
          <ProtectedRoute allowedRoles={["admin", "headquaters"]}>
            <AdminDetailViewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/adduser",
        element: (
          <ProtectedRoute allowedRoles={["admin", "headquaters"]}>
            <AdminRegistrationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit/:id",
        element: (
          <ProtectedRoute allowedRoles={["admin", "headquaters"]}>
            <AdminEditViewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/kyactivitylist",
        element: (
          <ProtectedRoute allowedRoles={["admin", "headquaters"]}>
            <KYActivityListPage />
          </ProtectedRoute>
        ),
      },
    ],
  },

  // ----------- User Routes -----------
  {
    element: <SiteLayout />,
    children: [
      { path: "/demo/nyuujou", element: <FaceCameraPage /> },
      { path: "/demo", element: <Navigate to="/demo/nyuujou" replace /> },
      { path: "/demo/nyuujou/seikou", element: <AllDoneSuccess /> },
      { path: "/kyactivity", element: <KYActivityPage /> },
      { path: "/shokai", element: <PhoneLoginPage /> },
      { path: "/shokai/touroku", element: <UserRegistrationPage /> },
      { path: "/shokai/kanri/:id", element: <UserDetailsPage /> },
      { path: "/shokai/henshuu/:id", element: <EditViewPage /> },
      { path: "/shokai/kojinerror", element: <UserNotExist /> },
      { path: "/shokai/koshinmsg", element: <UpdateMessage /> },
      { path: "/shokai/tourokumsg", element: <RegisterMessage /> },
      { path: "/shinki/touroku", element: <SiteEntryAdd /> },
      { path: "/shinki/kyouiku", element: <EntryTraining /> },
      { path: "/nyuujou/seikou", element: <AllDoneSuccess /> },
      { path: "/nyuujou", element: <PhoneLoginPage /> },
      { path: "/nyuujou/shinkierror", element: <EntryTrainingMessage /> },
      { path: "/taijou", element: <ExistScreen /> },
      { path: "/shinki", element: <PhoneLoginPage /> },
    ],
  },

  // ----------- Error / Fallback Routes -----------
  { path: "/not-authorized", element: <NotAuthorized /> },
  { path: "*", element: <NotFound /> },
];
